<i18n>
{
	"en": {
		"cancel": "Cancel",
		"no": "No",
		"yes": "Yes"
	},
	"no": {
		"cancel": "Avbryt",
		"no": "Nei",
		"yes": "Ja"
	}
}
</i18n>

<template>
	<t-dialog
		:isShown="isShown"
		:hasHeader="false"
		alwaysRememberFocus
		:shouldCloseOnEscapePress="false"
		:shouldCloseOnOverlayClick="false"
		width="480px"
	>
		{{message}}

		<template v-slot:footer>
			<t-button
				:value="$t('cancel')"
				width="100%"
				@click="$emit('cancel')"
			/>
			<t-button
				:value="$t('no')"
				appearance="primary"
				intent="danger"
				class="timpex-modal-button"
				width="100%"
				@click="$emit('no')"
			/>
			<t-button
				:value="$t('yes')"
				appearance="primary"
				class="timpex-modal-button"
				width="100%"
				@click="$emit('yes')"
			/>
		</template>
	</t-dialog>
</template>

<script>
export default {
	name: 'ConfirmCancelDialog',
	props: {
		isShown: Boolean,
		message: {
			type: String,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.timpex-modal-button {
	margin-left: 12px;
}
</style>